import type { OperationalTimelineEntryHydration } from '../executionOperations/types';

export type MutationTimelineItem = {
  key: string;
  at: string | null;
  title: string;
  reason: string | null;
  diffSummary: string | null;
};

export function buildMutationTimelineFromHydration(
  entries: OperationalTimelineEntryHydration[] | undefined
): MutationTimelineItem[] {
  if (!entries?.length) return [];
  return entries
    .filter((e) => e.type === 'mutation' || e.category?.includes('mutation'))
    .map((e) => ({
      key: e.key,
      at: e.timestamp,
      title: e.title,
      reason: null,
      diffSummary: null
    }));
}

export function buildMutationTimelineFromAudits(
  audits: Array<{ action: string; createdAt: string; context?: unknown; newState?: unknown }> | undefined
): MutationTimelineItem[] {
  if (!audits?.length) return [];
  return audits
    .filter((a) => a.action.startsWith('mutation_'))
    .map((a) => {
      const ctx = (a.context ?? {}) as Record<string, unknown>;
      const newState = (a.newState ?? {}) as {
        diff?: { compactText?: string[] };
        events?: Array<{ title: string; diffLines?: string[] }>;
      };
      const diffLine =
        newState.diff?.compactText?.[0] ??
        newState.events?.[0]?.diffLines?.join('; ') ??
        null;
      const eventTitle = newState.events?.[0]?.title;
      const classification =
        ctx.classification != null ? String(ctx.classification) : null;
      return {
        key: `audit-${a.createdAt}`,
        at: a.createdAt,
        title: String(eventTitle ?? ctx.mutationReasonLabel ?? 'Изменение маршрута'),
        reason:
          ctx.mutationReason != null
            ? String(ctx.mutationReasonLabel ?? ctx.mutationReason)
            : classification
              ? `Классификация: ${classification}`
              : null,
        diffSummary: diffLine
      };
    });
}
